//@flow

export const SourceType = Object.freeze({
  ICECAST: "icecast",
  HLS: "hls",
});
export class AudioSource {
  title: string;
  description: string;
  src: string;
  srctype: string;
  img: string;
  isLiveStream: boolean;
  // stationID: string;
  id:string
}
